const formatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	minimumFractionDigits: 2,
})

export default function useMoneyFormatter(): Intl.NumberFormat {
	return formatter
}
